<template>
    <div data-layout="phoenix" class="phoenix-body gradient min-h-screen flex flex-col px-5 pt-5">
        <geo-watcher />
        <div class="steppingstone-content flex flex-grow rounded-lg">
            <AppBoxContent :bgClassColor="'bg-transparent'" :removeStyling="true">
                <div class="box-content-white mx-auto">
                    <div class="content-container flex-grow rounded-r-lg sm:px-20 md:pt-10">
                        <div class="bg-white bg-opacity-65 rounded-lg p-5 text-white">
                          <div class="logo-and-contact-us-ling flex flex-col md:flex-row justify-between items-center">
                                <div class="logo-container">
                                    <a href="#">
                                        <AppLogo />
                                    </a>
                                </div>
                                <div class="contact-us-link">
                                    <a class="text-black no-underline" :href="$root.app.mailtoSupport">{{ $root.app.support_email }}</a>
                                </div>
                            </div>

                            <div class="text-black content mt-6 md:mt-14">
                                <slot />
                            </div>
                        </div>
                    </div>
                </div>
            </AppBoxContent>
        </div>

        <PhoenixFooter />
    </div>
</template>

<script>
import AppLogo from "./../../components/AppLogo";
import AppBoxContent from "./../../components/AppBoxContent.vue";
import PhoenixFooter from "./components/PhoenixFooter.vue";
import GeoWatcher from "../../components/GeoWatcher.vue";

export default {
    components: {
        AppLogo,
        PhoenixFooter,
        AppBoxContent,
        GeoWatcher,
    },
    // beforeCreate() {
    //     // import AppBoxContent
    //     this.$options.components.AppBoxContent = AppBoxContent;
    // },
    data() {
        return {};
    },
};
</script>
